var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/thunk.ts
var CallThunk = class {
  constructor() {
    // 存储 Thunk 的计算结果
    __publicField(this, "callMap");
    this.callMap = {};
  }
  /**
   * 定义 thunk
   * @param thunkName - thunk 的名称
   * @param fn - thunk 的计算函数
   * @example
   * ```typescript
   * // 如果是全局定义
   * import call from '@byted/tiktok-zti-call';
   * decale global {
   *   interface CallThunkMap {
   *      alert: (param: string) => boolean
   *   }
   * }
   * call.define('alert', () => {
   *    return (param) => {
   *       return true;
   *    }
   * });
   *
   * // 如果是自定义
   * import {CallThunk} from '@byted/tiktok-zti-call';
   * const call = new CallThunk<{alert: () => boolean}>();
   * call.define('alert', () => {
   *    return (param: string) => {
   *      return true;
   *    };
   * })
   *
   *
   * // 使用
   * call.thunk('alert')('string');
   * ```
   */
  define(thunkName, fn) {
    this.callMap[thunkName] = fn();
  }
  /**
   * 获取 thunk 函数
   * @param thunkName - thunk 的名称
   * @returns 返回指定的 thunk 函数，如果不存在返回一个空函数并输出警告信息
   */
  thunk(thunkName) {
    const { callMap } = this;
    const fn = callMap[thunkName];
    if (typeof fn === "function") {
      return fn;
    }
    return () => {
      if (typeof console !== "undefined" && typeof console.warn === "function") {
        console.warn(`The \`${String(thunkName)}\` is a noop thunk.`);
      }
    };
  }
};
var thunk_default = CallThunk;

// src/event.ts
var CallEvent = class {
  constructor() {
    // eventMap 属性，键为事件名，对应值为该事件的所有回调函数（数组形式）
    __publicField(this, "eventMap");
    this.eventMap = {};
  }
  // on 方法，为指定事件添加回调函数
  on(eventName, handle) {
    const { eventMap } = this;
    if (eventMap[eventName]) {
      eventMap[eventName].push(handle);
    } else {
      eventMap[eventName] = [handle];
    }
  }
  // off 方法，为指定事件移除指定或所有回调函数
  off(eventName, handle) {
    const { eventMap } = this;
    if (eventMap[eventName]) {
      const array = eventMap[eventName];
      for (let i = array.length; i >= 0; i--) {
        if (!handle || array[i] === handle) {
          array.splice(i, 1);
        }
      }
    }
  }
  // emit 方法，触发指定事件，执行其所有回调函数
  emit(eventName, args) {
    const { eventMap } = this;
    const obj = eventMap[eventName];
    if (obj) {
      [...obj].forEach((fn) => {
        fn(args);
      });
    }
  }
  // has 方法，判断是否存在指定事件及其回调函数
  has(eventName, handle) {
    const { eventMap } = this;
    if (eventMap[eventName]) {
      if (typeof handle === "function") {
        return eventMap[eventName].indexOf(handle) !== -1;
      }
      return true;
    }
    return false;
  }
};
var event_default = CallEvent;

// src/lib.ts
var globalObject = typeof globalThis !== "undefined" ? globalThis : typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {};

// src/index.ts
var gWindow = globalObject;
if (!gWindow.$$CallThunkInstance) {
  gWindow.$$CallThunkInstance = ((callThunk) => {
    callThunk.channel = new event_default();
    return callThunk;
  })(new thunk_default());
}
var src_default = gWindow.$$CallThunkInstance;
var call = gWindow.$$CallThunkInstance;
export {
  CallEvent,
  CallThunk,
  call,
  src_default as default,
  gWindow
};
